import { useState, useEffect, useRef } from 'react';
import { Auth } from 'aws-amplify';
import { Link } from 'react-router-dom';
import { useSearchParams } from 'react-router-dom';

import { FormattedMessage } from 'react-intl';
import Button from '../../../components/Button';
import CenteredPage from '../../../containers/CenteredPage';

const timeout = 30;

const SignUpSuccessful = () => {
  const [resent, setResent] = useState(false);

  const [disabled, setDisabled] = useState(timeout);

  const intervalRef = useRef();

  const [searchParams] = useSearchParams();
  const username = searchParams.get('username');

  useEffect(() => {
    if (disabled <= 0) {
      clearInterval(intervalRef.current);
      intervalRef.current = null;
    }
  }, [disabled]);

  const resetTimer = () => {
    setDisabled(timeout);

    requestAnimationFrame(() => {
      intervalRef.current = setInterval(() => {
        setDisabled((prev) => {
          return prev - 1;
        });
      }, 1000);
    });
  };

  useEffect(() => {
    resetTimer();

    return () => {
      if (intervalRef.current) {
        clearInterval(intervalRef.current);
      }
    };
  }, []);

  const handleResend = async () => {
    if (!username) {
      return;
    }

    resetTimer();

    try {
      try {
        await Auth.resendSignUp(username, {});
        console.log('code resent successfully');
      } catch (err) {
        console.log('error resending code: ', err);
      }

      setResent(true);

      setTimeout(() => {
        setResent(false);
      }, 5000);
    } catch (error) {
      console.log('error signing up:', error);
    }
  };

  return (
    <CenteredPage className="flex-column py-5" style={{ maxWidth: 520 }}>
      <h1 className="mb-2">
        <FormattedMessage defaultMessage="Registrering lyckades" />
      </h1>

      <p>
        <FormattedMessage defaultMessage="Du bör snart få ett e-postmeddelande med en länk för att verifiera ditt konto. Om du inte har fått något meddelande kan du skicka ett nytt verifierings-mejl inom kort." />{' '}
      </p>

      {resent && (
        <p>
          <FormattedMessage defaultMessage="Ett nytt verifieringsmejl har skickats till dig." />
        </p>
      )}

      <div className="d-flex flex-column">
        <Button onClick={handleResend} disabled={disabled}>
          {disabled ? (
            <FormattedMessage
              defaultMessage="Skicka igen (om {timeLeft} sekunder)"
              values={{ timeLeft: disabled }}
            />
          ) : (
            <FormattedMessage defaultMessage="Skicka igen" />
          )}
        </Button>

        <div className="d-flex w-100 justify-content-center mt-3 align-items-center">
          <Link to="/sign-in">
            <FormattedMessage defaultMessage="Till inloggning" />
          </Link>
        </div>
      </div>
    </CenteredPage>
  );
};

export default SignUpSuccessful;
